import { availableInternationalization, fallbackInternationalization, Errors, chineseExchangeableLanguages, defaultInternationalization, defaultLanguages, notCurrentAvailableInternationalization, notCurrentAvailableInternationalizationFls, notCurrentAvailableInternationalizationPROD } from 'corporate-types';
import { Logger } from '../logger/logger';
export const internationalizationToLanguages = (internationalization, from) => {
    var _a, _b;
    if (Object.values(defaultLanguages).indexOf(internationalization) !== -1) {
        internationalization = defaultInternationalization;
    }
    const internationalizationFoundkey = Object.keys(availableInternationalization).find((key) => availableInternationalization[key] === internationalization);
    const internationalizationSplitted = internationalization === null || internationalization === void 0 ? void 0 : internationalization.split('-');
    const internationalizationFoundFallbackKey = internationalizationSplitted.length > 1 ? internationalizationSplitted[0].toLocaleLowerCase() : undefined;
    if (internationalizationFoundkey || internationalizationFoundFallbackKey) {
        const internationalizationFound = (_a = internationalizationFoundkey) !== null && _a !== void 0 ? _a : availableInternationalization[internationalizationFoundkey];
        const internationalizationFallbackFound = (_b = internationalizationFoundFallbackKey) !== null && _b !== void 0 ? _b : availableInternationalization[internationalizationFoundFallbackKey];
        const language = fallbackInternationalization[internationalizationFound];
        const languageFallback = fallbackInternationalization[internationalizationFallbackFound];
        if (language) {
            return language;
        }
        else if (languageFallback) {
            return languageFallback;
        }
        else {
            console.error(Errors.NO_FALLBACK_FOUND, availableInternationalization, internationalization, internationalizationFoundkey, internationalizationFoundFallbackKey, from);
            return undefined;
        }
    }
    else {
        console.error(Errors.NO_INTERNATIONALIZATION_FOUND, availableInternationalization, internationalization, internationalizationFoundkey, internationalizationFoundFallbackKey, from);
        return undefined;
    }
};
export const checkExchangeableLocalization = (locale) => {
    if (chineseExchangeableLanguages.includes(locale))
        return chineseExchangeableLanguages;
    return [locale];
};
export const LANGS = Object.values(availableInternationalization).filter((value) => {
    return Object.values(notCurrentAvailableInternationalization).indexOf(value) === -1;
});
export const LANGS_PROD = Object.values(availableInternationalization).filter((value) => {
    return Object.values(notCurrentAvailableInternationalizationPROD).indexOf(value) === -1;
});
export const LANGS_FLS = Object.values(availableInternationalization).filter((value) => {
    return Object.values(notCurrentAvailableInternationalizationFls).indexOf(value) === -1;
});
export const getCorrectLangs = (env, company) => {
    let langs;
    Logger.debug('packages/corporate-lambdas/src/models/lang.ts env', env);
    Logger.debug('packages/corporate-lambdas/src/models/lang.ts company', company);
    switch (company) {
        case 'sirman': {
            langs = env === 'prod' ? LANGS_PROD : LANGS;
            break;
        }
        case 'felsinea': {
            langs = LANGS_FLS;
            break;
        }
        default: {
            langs = [];
            break;
        }
    }
    Logger.debug('packages/corporate-lambdas/src/models/lang.ts langs', langs);
    return langs;
};
//# sourceMappingURL=languages.js.map